import { useState } from 'react';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-b from-black to-blue-950 border-t border-white/10">
      {/* Newsletter Section */}
      <div className="py-16 border-b border-white/10">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-white/10 rounded-full mb-8">
              <i className="ri-mail-line text-2xl text-white"></i>
            </div>
            <h3 className="text-3xl md:text-4xl font-bold text-white mb-6">
              Stay Updated
            </h3>
            <p className="text-lg text-white/80 font-light mb-8 max-w-2xl mx-auto">
              Get the latest updates on new projects, token launches, and community milestones
            </p>
            
            <a
              href="https://forms.gle/2GE78MMrFUHBdtDW8"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center bg-white text-black px-8 py-4 rounded-full font-semibold text-lg hover:bg-blue-100 transition-all duration-300 transform hover:scale-105 hover:shadow-2xl whitespace-nowrap cursor-pointer"
            >
              Subscribe to Updates
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="py-16">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-4 gap-12">
            {/* Brand */}
            <div className="md:col-span-2">
              <div className="flex items-center mb-6">
                <div className="inline-flex items-center justify-center w-12 h-12 mr-4">
                  <img 
                    src="https://static.readdy.ai/image/0e46e23e46c8c9dfddbf3ffa9f8570fe/7c8fb1bd017777596a8092832d4ffea3.png" 
                    alt="StartupCoin Logo" 
                    className="w-full h-full object-contain"
                  />
                </div>
                <div>
                  <h4 className="text-2xl font-bold text-white">StartupCoin</h4>
                  <div className="text-blue-200">$Startup</div>
                </div>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h5 className="text-lg font-semibold text-white mb-6">Quick Links</h5>
              <ul className="space-y-3">
                <li>
                  <a href="#about" className="text-white/80 hover:text-white transition-colors duration-300 cursor-pointer">
                    About
                  </a>
                </li>
                <li>
                  <a href="#how-it-works" className="text-white/80 hover:text-white transition-colors duration-300 cursor-pointer">
                    How It Works
                  </a>
                </li>
                <li>
                  <a href="#projects" className="text-white/80 hover:text-white transition-colors duration-300 cursor-pointer">
                    Projects
                  </a>
                </li>
                <li>
                  <a
                    href="https://forms.gle/2GE78MMrFUHBdtDW8"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white/80 hover:text-white transition-colors duration-300 cursor-pointer"
                  >
                    Submit Dream
                  </a>
                </li>
              </ul>
            </div>

            {/* Community */}
            <div>
              <h5 className="text-lg font-semibold text-white mb-6">Community</h5>
              <div className="space-y-4">
                <a href="https://x.com/home" target="_blank" rel="noopener noreferrer" className="flex items-center text-white/80 hover:text-white transition-colors duration-300 group cursor-pointer">
                  <i className="ri-twitter-line mr-3 group-hover:scale-110 transition-transform duration-300"></i>
                  Twitter
                </a>
                <a href="#" className="flex items-center text-white/80 hover:text-white transition-colors duration-300 group cursor-pointer">
                  <i className="ri-telegram-line mr-3 group-hover:scale-110 transition-transform duration-300"></i>
                  Telegram
                </a>
                <a href="#" className="flex items-center text-white/80 hover:text-white transition-colors duration-300 group cursor-pointer">
                  <i className="ri-discord-line mr-3 group-hover:scale-110 transition-transform duration-300"></i>
                  Discord
                </a>
                <a href="#" className="flex items-center text-white/80 hover:text-white transition-colors duration-300 group cursor-pointer">
                  <i className="ri-github-line mr-3 group-hover:scale-110 transition-transform duration-300"></i>
                  GitHub
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="py-8 border-t border-white/10">
        <div className="container mx-auto px-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-white/60 text-sm mb-4 md:mb-0">
              © 2024 StartupCoin. All rights reserved.
            </div>
            <div className="flex items-center space-x-6">
              <a href="#" className="text-white/60 hover:text-white text-sm transition-colors duration-300 cursor-pointer">
                Privacy Policy
              </a>
              <a href="#" className="text-white/60 hover:text-white text-sm transition-colors duration-300 cursor-pointer">
                Terms of Service
              </a>
              <a 
                href="https://readdy.ai/?origin=logo" 
                className="text-white/60 hover:text-white text-sm transition-colors duration-300 cursor-pointer"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
